import React, { useEffect, useState } from 'react';
interface HeroProps {
  openModal: () => void;
}
export function Hero({
  openModal
}: HeroProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-white" data-id="element-108">
      {/* Content */}
      <div className={`relative z-20 w-full max-w-6xl mx-auto px-6 py-32 transition-opacity duration-1000 ease-out text-center ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-109">
        <h1 className="font-bold text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6 text-charcoal-500" data-id="element-110">
          Stop Guessing.
          <br data-id="element-111" />
          Start Eating.
        </h1>
        <p className="text-charcoal-400 text-xl md:text-2xl leading-relaxed mb-6 max-w-3xl mx-auto" data-id="element-112">
          Find restaurants that actually fit your macros—before you even look at
          the menu.
        </p>
        <p className="text-charcoal-400 text-lg leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-113">
          Caltalk + your macros + local restaurants = instant meal matches near
          you
        </p>

        {/* Chat Interface Images */}
        <div className="mb-12 flex flex-col md:flex-row items-center justify-center gap-8" data-id="element-114">
          <div className="relative max-w-xs mx-auto" data-id="element-115">
            <div className="absolute -inset-4 bg-gradient-to-r from-coral-400/20 to-peach-500/10 blur-2xl rounded-3xl" data-id="element-116" />
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/nVkEQwPzvdwVhTDK5kmz9j/image_118.png" alt="Caltalk chat interface showing macro tracking and gluten-free options" className="w-full h-auto" data-id="element-118" />
            </div>
          </div>

          <div className="relative max-w-xs mx-auto" data-id="element-119">
            <div className="absolute -inset-4 bg-gradient-to-r from-coral-400/20 to-peach-500/10 blur-2xl rounded-3xl" data-id="element-120" />
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/4s4PR2YiAWG1uCcnhAtbCi/image_143.png" alt="Caltalk showing restaurant recommendations with nutritional information" className="w-full h-auto" data-id="element-122" />
            </div>
          </div>
        </div>

        <button onClick={openModal} className="px-10 py-5 text-lg font-semibold rounded-full bg-gradient-coral text-white hover:bg-gradient-coral-hover transition-all duration-300 shadow-2xl hover:shadow-coral-500/30 hover:scale-105" data-id="element-123">
          Download Now
        </button>
      </div>
    </div>;
}